<template>
    <div class="memberShipWarp">
        <div class="infowarp">
            <div class="lefthandlebox">
                <div class="titleBox">入会申请</div>
                <!-- logo -->
                <!-- <img :src='srcUrl+logo' class="headerImg" v-else /> -->
                <div class="companybox">{{this.ruleForm.corpInfoName}}</div>
                <div class="username">{{this.ruleForm.userName}}</div>
            </div>
            <div class="rightformbox">
                <!-- 会员用户 -->
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm" v-if="ismember" :validate-on-rule-change="false">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="用户名" prop="userName">
                                <el-input v-model="ruleForm.userName" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="头像" prop="logo">
                                <el-upload id="imgupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="logoSuccess" :on-remove="logoRemove"
                                    :action="actionUrl" :limit="1" :file-list="logoList">
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <div v-show="channelId==0"> -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="单位名称" prop="corpInfoName">
                                <el-input v-model="ruleForm.corpInfoName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="曾用名或注册名" prop="oldCorpInfoName">
                                <el-input v-model="ruleForm.oldCorpInfoName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="统一社会信用代码" prop="organizingCord">
                                <el-input v-model="ruleForm.organizingCord"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <div v-if="channelId!=0"> -->
                    <!-- <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="单位名称" prop="corpInfoName">
                                    <el-input v-model="ruleForm.corpInfoName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="统一社会信用代码" prop="organizingCord">
                                    <el-input v-model="ruleForm.organizingCord"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row> -->
                    <!-- 选择入会渠道的时候不能选择分会，选择分会自动带出所属分会，不能修改 -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="入会渠道" prop="channel">
                                <el-select v-model="ruleForm.channel" placeholder="请选择入会渠道" style="width:100%" @change='changeChannel($event)'>
                                    <el-option v-for="item in channelArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="总会会员等级" prop="memberlevel">
                                <el-select v-model="ruleForm.memberlevel" placeholder="请选择总会会员等级" style="width:100%">
                                    <el-option v-for="item in membershipArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="channelId!=0">
                        <el-col :span="12">
                            <el-form-item label="所属分会" prop="branchRegion">
                                <el-select v-model="ruleForm.branchRegion" placeholder="请选择所属分会" style="width:100%" :disabled="disabled">
                                    <el-option v-for="item in branchProvinceArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <!-- 分会会员等级 -->
                            <!-- @change="changebranchmemberlevel($event)" -->
                            <el-form-item label="所属分会等级" prop="branchmemberlevel">
                                <el-select v-model="ruleForm.branchmemberlevel" placeholder="请选择所属分会会员等级" style="width:100%" @change="changebranchmemberlevel($event)">
                                    <el-option v-for="item in MemberOrderArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- </div> -->
                    <!-- </div> -->
                    <!-- <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="单位名称" prop="corpInfoName">
                                <el-input v-model="ruleForm.corpInfoName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="channelId!=0">
                            <el-form-item label="所属分会" prop="branchRegion">
                                <el-select v-model="ruleForm.branchRegion" placeholder="请选择所属分会" style="width:100%" v-if="!channelId">
                                    <el-option v-for="item in branchProvinceArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                                <el-select v-model="ruleForm.branchRegion" placeholder="请选择所属分会" style="width:100%" :disabled="true" v-else>
                                    <el-option v-for="item in branchProvinceArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>

                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-else>
                            <el-form-item label="统一社会信用代码" prop="organizingCord">
                                <el-input v-model="ruleForm.organizingCord"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12" v-if="channelId!=0">
                            <el-form-item label="统一社会信用代码" prop="organizingCord">
                                <el-input v-model="ruleForm.organizingCord"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="channelId!=0">
                            <el-form-item label="" prop="branchmemberlevel">
                                <el-select v-model="ruleForm.branchmemberlevel" placeholder="请选择所属分会会员等级" style="width:100%" @change="changebranchmemberlevel">
                                    <el-option v-for="item in MemberOrderArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-row :gutter="0">
                                <el-form-item label="注册地址" prop='regionalCode'>
                                    <el-col :span="8">
                                        <el-select v-model="ruleForm.city.province" placeholder="请选择省份" @change="onProvinces($event)" style="width:100%">
                                            <el-option v-for="item in ProvinceArr" :key="item.provinceId" :label="item.province" :value="item.province"></el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-select v-model="ruleForm.city.town" placeholder="请选择市区" style="width:100%" @change="onTowns($event)">
                                            <el-option v-for="item in CityArr" :key="item.cityId" :label="item.city" :value="item.city"></el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-select v-model="ruleForm.city.county" placeholder="请选择县" style="width:100%" @change="countyFn($event)">
                                            <el-option v-for="item in CountyArr" :key="item.areaId" :label="item.area" :value="item.area"></el-option>
                                        </el-select>
                                    </el-col>
                                </el-form-item>
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-row :gutter="20">
                                <div class="reigstMoney">
                                    <el-form-item label="注册资金" prop="registeredMoney">
                                        <el-input placeholder="请输入" v-model="ruleForm.registeredMoney" class="input-with-select">
                                            <el-select v-model="ruleForm.registeredMoneyType" slot="prepend" placeholder="请选择" style="width:90px">
                                                <el-option v-for="item in currencyArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                                </el-option>
                                            </el-select>
                                            <template slot="append">万元</template>
                                        </el-input>
                                    </el-form-item>
                                </div>

                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="单位规模" prop="corpScale">
                                <el-select v-model="ruleForm.corpScale" placeholder="请选择单位规模" style="width:100%">
                                    <el-option v-for="item in UnitSizeArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="单位类型" prop="organizingCordType" class="organizingFormItem">
                                <div class="organizingText">
                                    <el-popover placement="top-start" title="单位类型说明:" width="720" trigger="hover">
                                        <div>
                                            <p>
                                                综合性公共就业和人才服务机构：由县级以上政府人力资源社会保障部门设立，面向用人单位和求职者提供就业和人才流动配置等各类公共服务的综合性机构，其主体是由原公共就业服务机构和人才交流服务机构合并设立的。
                                            </p>
                                            <p>公共就业服务机构：由县级以上政府人力资源社会保障部门设立，承担基本公共就业服务，帮助各类就业困难群体实现就业的服务机构。</p>
                                            <p>人才公共服务机构：由县级以上政府人力资源社会保障部门设立，主要面向各类人才和用人单位提供相关服务，承担公共人才服务职能的公益性服务机构。</p>
                                            <p>行业所属服务机构（事业单位）：由人社部门以外的其他行业部门举办的面向本行业提供人力资源服务的事业单位性质的人力资源服务机构。</p>
                                            <p>国有性质的服务企业：指从事人力资源服务的国有企业、地方各级政府人力资源和社会保障部门所属人才（职业）服务机构设立的公司性质的机构。</p>
                                            <p>民营性质的服务企业：指根据人力资源市场的相关规定，设立的由民间经营、为社会提供人力资源服务的机构。</p>
                                            <p>外资性质的服务企业：指按照我国人力资源市场的有关规定，成立的具有外资性质的人力资源服务企业。</p>
                                            <p>港、澳、台性质的服务企业：指按照我国人力资源市场的有关规定，成立的具有港、澳、台资性质的人力资源服务企业。</p>
                                            <p>民办非企业等其他性质的服务机构：指除上述人力资源服务机构以外的民办非企业等其他性质的服务机构。</p>
                                        </div>
                                        <div slot="reference">说明</div>
                                    </el-popover>
                                </div>
                                <el-select v-model="ruleForm.organizingCordType" placeholder="请选择单位类型" style="width:100%">
                                    <el-option v-for="item in organizingCordTypeArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="法定代表人" prop="legalPersonName">
                                <el-input v-model="ruleForm.legalPersonName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="成立日期" prop="registeredTime">
                                <el-date-picker v-model="ruleForm.registeredTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"
                                    style="width:100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="主营业务" prop="mainBusiness">
                                <el-select v-model="ruleForm.mainBusiness" placeholder="请选择主营业务" style="width:100%" multiple>
                                    <el-option v-for="item in mainBusinessArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="上市公司 " prop="isListedCorp">
                                <el-radio-group v-model="ruleForm.isListedCorp">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="通讯地址" prop="currentSite">
                                <el-input v-model="ruleForm.currentSite"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <div class="acceptMailBox">
                                <el-form-item label="全国性社会团体会费统一票据接收邮箱" prop="acceptMail">
                                    <el-input v-model="ruleForm.acceptMail"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">

                        <el-col :span="12">
                            <el-form-item label="邮编" prop="postalCord">
                                <el-input v-model="ruleForm.postalCord"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="单位网址" prop="website">
                                <el-input v-model="ruleForm.website"></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12">
                            <el-form-item label="传真" prop="fox">
                                <el-input v-model="ruleForm.fox"></el-input>
                            </el-form-item>
                        </el-col> -->
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="单位简介" prop="remark">
                                <el-input type="textarea" :rows="6" placeholder="请输入内容" minlength='300' show-word-limit maxlength="1000" v-model="ruleForm.remark">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <div v-show="!isunfold">
                        <el-divider>
                            <div class="unfoldbox" @click="unfoldFn">
                                <img :src="unfoldicon" />
                                <span>展开</span>
                            </div>
                        </el-divider>
                    </div> -->
                    <!-- <div class="hiddenform" ref='hiddenform'> -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="联系人姓名" prop="linkName.linkName">
                                <el-input v-model="ruleForm.linkName.linkName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人手机号码" prop="linkName.phone">
                                <el-input v-model="ruleForm.linkName.phone" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="联系人职务" prop="linkName.contactPost">
                                <el-input v-model="ruleForm.linkName.contactPost"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人邮箱" prop="linkName.email">
                                <el-input v-model="ruleForm.linkName.email"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="联系人身份证号码" prop="linkName.cardCode">
                                <el-input v-model="ruleForm.linkName.cardCode"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人办公电话" prop="linkName.officePhone">
                                <el-input v-model="ruleForm.linkName.officePhone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="联系人微信号" prop="linkName.weChat">
                                <el-input v-model="ruleForm.linkName.weChat"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="负责人姓名" prop="principal.linkName">
                                <el-input v-model="ruleForm.principal.linkName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="负责人手机号码" prop="principal.phone">
                                <el-input v-model="ruleForm.principal.phone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="负责人职务" prop="principal.contactPost">
                                <el-input v-model="ruleForm.principal.contactPost"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="负责人邮箱" prop="principal.email">
                                <el-input v-model="ruleForm.principal.email"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="负责人身份证号码" prop="principal.cardCode">
                                <el-input v-model="ruleForm.principal.cardCode"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="负责人办公电话" prop="principal.officePhone">
                                <el-input v-model="ruleForm.principal.officePhone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="负责人微信号" prop="principal.weChat">
                                <el-input v-model="ruleForm.principal.weChat"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="备注" prop="postscript">
                                <!-- minlength='300' show-word-limit maxlength="1000" -->
                                <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="ruleForm.postscript">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- </div>
                    <div v-show="isunfold">
                        <el-divider>
                            <div class="unfoldbox" @click="packupFn">
                                <img :src="packupicon" />
                                <span>收起</span>
                            </div>
                        </el-divider>
                    </div> -->
                    <div class="handleBtnBox" v-if="!auditType||auditType==99||auditType==2">
                        <el-button type="primary" @click="submitForm('ruleForm')" class="savebtn">保存并进入下一步</el-button>
                        <el-button @click="cancelFormFn" class="cancelbtn">取消</el-button>
                    </div>
                </el-form>
            </div>
        </div>
        <!-- 第二步上传资料 -->
        <MemberFileupModal :isShow.sync="fileVisible" v-if="fileVisible" @offSecondModal='offSecondModal' :userId='userId' :formObj='formObj'
        />
        <!-- 第三步资料上传成功 -->
        <ThirdModal :isShow.sync="thirdVisible"   v-if="thirdVisible" @thirdshowModal='thirdshowModal' />
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import { formErrorScroll } from '@/utils'
import MemberFileupModal from './memberFileupModal'
import ThirdModal from './thirdModal'
import { setTimeout } from 'timers';
export default {
    components: {
        MemberFileupModal,
        ThirdModal
    },
    data() {
        var validatePhone = (rule, value, callback) => {
            let reg = /^1[3|4|5|7|8][0-9]\d{8}$/
            if (value === '') {
                callback(new Error('请输入联系人手机号码'));
            } else if (!reg.test(value)) {
                callback(new Error('手机号码格式不正确,即将前往修改页面，填写正确格式的手机号码'));
                setTimeout(() => {
                    this.$router.push({
                        path: '/retrieve-phone',
                    })
                }, 2000)
                // this.dialogVisible=true
            } else {
                callback();
            }
        };
        return {
            srcUrl: srcUrl,
            headImgUrl: require("@/assets/imgs/account/header.png"),
            saveicon: require("@/assets/imgs/account/icon9.png"),
            unfoldicon: require("@/assets/imgs/account/unfold.png"),
            packupicon: require("@/assets/imgs/account/packup.png"),
            actionUrl: process.env.VUE_APP_GATEWAY + '/upload/addfile',
            ruleForm: {
                userName: '',
                channel: '',
                corpInfoName: '',
                oldCorpInfoName: '',
                branchRegion: '',
                branchmemberlevel: '',
                organizingCord: '',
                memberlevel: '',//总会会员等级
                registeredMoney: '',
                regionalCode: '',
                city: { // 三级联动
                    province: '',
                    town: '',
                    county: ''
                },
                corpScale: '',
                legalPersonName: '',
                organizingCordType: '',//单位类型
                registeredTime: '',//成立日期
                isListedCorp: '',
                mainBusiness: [],//主要业务
                website: '',
                currentSite: '',
                acceptMail: '',
                postalCord: '',
                fox: '',
                remark: '',
                linkName: {
                    linkName: '',
                    cardCode: '',
                    contactPost: '',
                    officePhone: '',
                    phone: '',
                    weChat: '',
                    email: ''
                },

                principal: {
                    linkName: '',
                    cardCode: '',
                    contactPost: '',
                    officePhone: '',
                    phone: '',
                    weChat: '',
                    email: ''
                },
                registeredMoneyType: '212',//默认资金类型
                postscript: '',
            },
            rules: {
                channel: [
                    { required: true, message: '请选择入会渠道', trigger: 'change' }
                ],
                corpInfoName: [
                    { required: true, message: '请输入单位名称', trigger: 'blur' },
                ],
                branchRegion: [
                    { required: true, message: '请选择所属分会', }
                ],
                branchmemberlevel: [
                    { required: true, message: '请选择所属分会会员等级', trigger: 'change' }
                ],
                organizingCord: [
                    { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
                ],
                regionalCode: [
                    { required: true, message: '请选择注册地址', trigger: 'change' }
                ],
                memberlevel: [
                    { required: true, message: '请选择总会会员等级', trigger: 'change' }
                ],
                registeredMoney: [
                    { required: true, message: '请输入注册资金', trigger: 'blur' },
                ],
                corpScale: [
                    { required: true, message: '请选择单位规模', trigger: 'change' }
                ],
                legalPersonName: [
                    { required: true, message: '请输入法定代表人', trigger: 'blur' },
                ],
                organizingCordType: [
                    { required: true, message: '请选择单位类型', trigger: 'change' }
                ],
                isListedCorp: [
                    { required: true, message: '请选择是否上市公司 ', trigger: 'change' }
                ],
                mainBusiness: [
                    { required: true, message: '请选择主营业务 ', trigger: 'change' }
                ],
                currentSite: [
                    { required: true, message: '请输入通讯地址', trigger: 'blur' },
                ],
                acceptMail: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                postalCord: [
                    { required: true, message: '请输入邮编', trigger: 'blur' },
                ],
                remark: [
                    { required: true, message: '请输入单位简介', trigger: 'blur' },
                    { min: 300, max: 1500, message: '请控制在300-1000个字符以内', trigger: 'blur' }
                ],
                "linkName.linkName": [
                    { required: true, message: '请输入联系人姓名', trigger: 'blur' },
                ],
                "linkName.phone": [
                    { required: true, message: '请输入联系人手机号码', trigger: 'blur', },
                    { validator: validatePhone, trigger: 'blur', required: true },
                    // { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur', message: '请输入正确的联系人手机号码', }

                ],
                "linkName.email": [
                    { required: true, message: '请输入联系人邮箱', trigger: 'blur', },

                    // { pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/, message: '请输入正确的联系人邮箱', trigger: 'blur' }
                    // { pattern: /\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}/, message: '请输入正确的联系人邮箱', trigger: 'blur' }
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                'linkName.cardCode': [
                    { message: '请输入正确的身份证号码', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, trigger: 'blur' }
                ],
                'principal.cardCode': [
                    { message: '请输入正确的身份证号码', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, trigger: 'blur' }
                ],
                'principal.email': [
                    // { pattern: /\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}/, message: '请输入正确的邮箱地址', trigger: 'blur' }
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
            },
            options: [{
                value: '人民币',
                label: '人民币'
            }, {
                value: '美元',
                label: '美元'
            }],

            ismember: true,
            // 展开收起状态
            isunfold: false,
            fileVisible: false,
            thirdVisible: false,
            MemberOrderArr: [],//分会会员等级
            organizingCordTypeArr: [],//组织机构类型
            mainBusinessArr: [],//主营业务
            branchProvinceArr: [],//所属分支机构
            UnitSizeArr: [],//单位规模
            channelArr: [],//入会渠道
            membershipArr: [],//总会会员等级 -默认普通会员
            ProvinceArr: [],//省
            CityArr: [],//市
            CountyArr: [],//县
            userId: '',
            token: sessionStorage.getItem('token'),
            formObj: null,
            auditType: '',
            // 0时是总会
            channelId: '',
            disabled: false,
            branchLabel: '',
            currencyArr: [],//币种
            logo: '',
            logoList: [],
        }
    },
    mounted() {
        // 数据字典
        this.dataDictionaryFn()
        // 获取省的数据
        this.getProvinceFn()
        // this.$nextTick(() => {
        //     // DOM 更新了
        //     this.$refs["ruleForm"].clearValidate()
        // })
        // 表单回显
        if (JSON.parse(sessionStorage.getItem('userInfo'))) {
            this.userId = JSON.parse(sessionStorage.getItem('userInfo')).userId
        } else {
            this.userId = sessionStorage.getItem('nologinuserId')
        }
        this.getmemberInfoFn()
        if (this.token) {
            this.getAuditFn()
        }
    },
    methods: {
        getAuditFn() {
            httpService.getCorpInfoOther(this.userId).then(res => {
                // 99保存 0提交审核中 1通过 2审核失败
                if (res.code == 200) {
                    this.auditType = res.result.audit
                    this.logo = res.result.logo
                    let logolist = []
                    if (this.logo) {
                        logolist = this.logo.split(',');
                        logolist = logolist.map((imgSrc, index) => {
                            return {
                                url: srcUrl + imgSrc,
                                uid: index,
                                name: imgSrc
                            };
                        });
                    }
                    this.logoList = logolist;
                    // 3分支机构 99保存 0提交审核 1入会 2驳回
                    if (this.auditType) {
                        if (this.auditType == 0 || this.auditType != 99 && this.auditType != 1 && this.auditType != 2) {
                            this.thirdVisible = true
                        }
                    }
                    // 头像如果有图片隐藏上传按钮
                    if (this.logoList.length > 0) {
                        document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'none'
                    }
                    // 头像如果有图片隐藏上传按钮
                    setTimeout(() => {
                        if (this.logoList.length > 0) {
                            document.querySelector('.el-upload--picture-card').style.display = 'none'
                        }
                    }, 500);
                }
            })
        },
        // 获取数据字典字段数据
        dataDictionaryFn() {
            // 分会会员等级
            let p1 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'branchLevel' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 组织机构类型
            let p2 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'organizingCordType' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 主营业务
            let p3 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'mainBusiness' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 所属分支机构
            let p4 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'branchRegion' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 单位规模UnitSizeArr corpScale
            let p5 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'corpScale' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 入会渠道
            let p6 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'channel' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 总会等级
            let p7 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'membership' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 币种
            let p8 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'currency' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            Promise.all([p1, p2, p3, p4, p5, p6, p7, p8]).then(res => {
                if (res) {
                    this.MemberOrderArr = res[0].result;//分会会员等级
                    this.organizingCordTypeArr = res[1].result;//组织机构类型
                    this.mainBusinessArr = res[2].result;//主营业务
                    this.branchProvinceArr = res[3].result;//所属分支机构
                    this.UnitSizeArr = res[4].result;//单位规模
                    this.channelArr = res[5].result;//入会渠道
                    this.membershipArr = res[6].result;//总会会员等级 -默认普通会员
                    this.currencyArr = res[7].result;//总会会员等级 -默认普通会员
                }
            })
        },
        // 省市县
        getProvinceFn() {
            httpService.getProvince().then(res => {
                if (res.code == 200) {
                    this.ProvinceArr = res.result
                }
            })
        },
        // 选择省
        onProvinces(event) {
            let provinceId
            this.ProvinceArr.map(item => {
                if (event === item.province) {
                    return provinceId = item.provinceId
                }
            })
            // 改变省之后市变化
            this.ruleForm.city.town = '';
            this.ruleForm.city.county = '';
            this.ruleForm.regionalCode = ''
            this.getCityData(provinceId)
            // console.log(this.ruleForm.regionalCode,'this.ruleForm.regionalCode');
        },
        // 获取市
        getCityData(provinceId) {
            httpService.getCity(provinceId).then(res => {
                if (res.code == 200) {
                    this.CityArr = res.result
                    // 回显地址
                    if (this.ruleForm.city.county) {
                        let cityId
                        this.CityArr.map(item => {
                            if (item.city === this.ruleForm.city.town) {
                                return cityId = item.cityId
                            }
                        })
                        this.getCountyData(cityId)
                    }
                }
            })
        },
        // 选择市
        onTowns(event) {
            let cityId
            this.CityArr.map(item => {
                if (event === item.city) {
                    return cityId = item.cityId
                }
            })
            this.ruleForm.city.county = '';
            this.ruleForm.regionalCode = ''
            this.getCountyData(cityId)
        },
        getCountyData(cityId) {
            httpService.getArea(cityId).then(res => {
                if (res.code == 200) {
                    this.CountyArr = res.result
                }
            })
        },
        // 选择区
        countyFn(event) {
            this.ruleForm.regionalCode = `${this.ruleForm.city.province},${this.ruleForm.city.town},${this.ruleForm.city.county}`
            this.$forceUpdate()//强制更新
        },
        // 提交表单
        submitForm(formName) {
            if (this.channelId == 0) {
                delete this.rules.branchRegion
                delete this.rules.branchmemberlevel
            } else {
                this.$set(this.rules, 'branchRegion', [
                    { required: true, message: '请选择所属分会', }
                ])
                this.$set(this.rules, 'branchmemberlevel', [
                    { required: true, message: '请选择所属分会会员等级', trigger: 'change' }
                ])
            }
            this.$refs[formName].validate((valid, object) => {
                if (valid) {
                    if (Array.isArray(this.ruleForm.regionalCode)) {
                        this.ruleForm.regionalCode = this.ruleForm.regionalCode.join(',')
                    }
                    this.ruleForm.audit = 99//保存
                    if (this.channelId == 0) {
                        this.ruleForm.branchData = null
                    } else {
                        this.ruleForm.branchData = [{
                            //  分支机构
                            branchRegion: this.ruleForm.branchRegion,
                            //  分会等级
                            memberlevel: this.ruleForm.branchmemberlevel
                        }]
                    }
                    if (Array.isArray(this.ruleForm.mainBusiness)) {
                        this.ruleForm.mainBusiness = this.ruleForm.mainBusiness.join(',')
                    }
                    httpService.addApply(this.ruleForm).then(res => {
                        if (res.code == 200) {
                            this.getmemberInfoFn()
                            this.fileVisible = true;
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                } else {
                    //    if (document.querySelector('.el-form-item__error')) {
                    //     document
                    //     .querySelector('.el-form-item__error')
                    //     .parentNode.scrollIntoView({
                    //     block: 'start',
                    //     behavior: 'smooth'
                    //     })
                    //     }
                    this.$nextTick(() => {
                        formErrorScroll()
                    })
                    return false;

                }
            });
        },
        cancelFormFn() {
            if (!this.token) {
                this.$router.push('/');
            } else {
                this.$router.push('/account-center/centerpage');
            }
        },
        // 图片上传相关
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        // 展开收起
        unfoldFn() {
            this.$refs.hiddenform.style.height = '500px'
            this.isunfold = true
        },
        packupFn() {
            this.$refs.hiddenform.style.height = '0px'
            this.$refs.hiddenform.addEventListener("transitionend", () => {
                this.isunfold = false
            }, true);
        },
        // 弹框关闭传值
        offSecondModal(data, isshow) {
            if (data.code == 200) {
                this.fileVisible = false
                setTimeout(() => {
                    this.thirdVisible = true
                }, 500);
            }

        },
        // 
        thirdshowModal(isshow) {
            this.thirdVisible = false
        },
        // 表单回显
        getmemberInfoFn() {
            httpService.getmemberInfo(this.userId).then(res => {
                if (res.code == 200) {
                    // 原始数据传给上传组件
                    this.formObj = res.result
                    // 还原地址和分支机构
                    res.result.city = {
                        province: '',
                        town: '',
                        county: ''
                    }
                    if (res.result.branchData.length != 0) {
                        res.result.branchRegion = res.result.branchData[0].branchRegion
                        res.result.branchmemberlevel = res.result.branchData[0].memberlevel
                    } else {
                        res.result.branchRegion = '';
                        res.result.branchmemberlevel = ''
                    }
                    if (res.result.regionalCode) {
                        res.result.regionalCode = res.result.regionalCode.split(',')
                        res.result.city.province = res.result.regionalCode[0]
                        res.result.city.town = res.result.regionalCode[1]
                        res.result.city.county = res.result.regionalCode[2]
                    } else {
                        res.result.city.province = ''
                        res.result.city.town = ''
                        res.result.city.county = ''
                    }
                    if (!res.result.registeredMoneyType) {
                        res.result.registeredMoneyType = '212'
                    }
                    this.logo = res.result.logo
                    let logolist = []
                    if (this.logo) {
                        logolist = this.logo.split(',');
                        logolist = logolist.map((imgSrc, index) => {
                            return {
                                url: srcUrl + imgSrc,
                                uid: index,
                                name: imgSrc
                            };
                        });
                    }
                    this.logoList = logolist;
                    this.ruleForm = res.result
                    this.channelId = this.ruleForm.channel
                    if (this.ruleForm.city.town) {
                        let provinceId
                        this.ProvinceArr.map(item => {
                            if (item.province === this.ruleForm.city.province) {
                                return provinceId = item.provinceId
                            }
                        })
                        this.getCityData(provinceId)
                    }
                    if (res.result.linkName == null || !res.result.linkName) {
                        this.ruleForm.linkName = {
                            linkName: '',
                            cardCode: '',
                            contactPost: '',
                            officePhone: '',
                            phone: '',
                            weChat: '',
                            email: ''
                        }
                    }
                    if (res.result.principal == null || !res.result.principal) {
                        this.ruleForm.principal = {
                            linkName: '',
                            cardCode: '',
                            contactPost: '',
                            officePhone: '',
                            phone: '',
                            weChat: '',
                            email: ''
                        }
                    }
                    if (this.ruleForm.mainBusiness) {
                        this.ruleForm.mainBusiness = this.ruleForm.mainBusiness.split(',')
                    } else {
                        this.ruleForm.mainBusiness = []
                    }
                    this.disabled = true
                    // if (res.result.materials2) {
                    //     sessionStorage.setItem('materialsFlag',res.result.materials2)
                    // }
                    this.$nextTick(() => {
                        // DOM 更新了
                        this.$refs["ruleForm"].clearValidate()
                        if (this.logoList.length > 0) {
                            document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'none'
                        }
                    })
                }
            })
        },
        // 选择的入会渠道
        changeChannel(event) {
            // 0时是总会
            // if (event==0) {
            //     this.channelId='总会'
            // }
            this.channelId = event
            this.ruleForm.branchmemberlevel = '';
            this.ruleForm.branchRegion = '';
            let channelName
            this.channelArr.map(item => {
                if (item.dictionariesId == event) {
                    return channelName = item.dictMsg
                }
            })
            if (this.channelId != 0) {
                this.branchProvinceArr.forEach(item => {
                    if (item.dictMsg == channelName) {
                        this.ruleForm.branchRegion = item.dictionariesId
                        // this.branchLabel = item.dictMsg
                    }
                })
            } else {
                this.disabled = true
            }
        },
        changebranchmemberlevel(event) {
            this.$set(this.ruleForm, 'branchmemberlevel', event)
            this.ruleForm = { ...this.ruleForm }
            this.$forceUpdate()
            // this.ruleForm.branchmemberlevel=event
        },
        // 头像上传
        logoSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.logoList = fileList
                this.ruleForm.logo = res.result
                if (this.logoList.length > 0) {
                    document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'none'
                }
            }
        },
        logoRemove() {
            this.logoList = []
            if (this.logoList.length == 0) {
                document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.memberShipWarp {
	width: 100%;
	box-sizing: border-box;
	padding: 20px 0 0 20px;
	.titleBox {
		font-size: 24px;
		font-weight: bold;
		line-height: 24px;
		color: #43424b;
		margin-bottom: 32px;
	}
	.acceptMailBox {
		/deep/.el-form-item__label {
			line-height: 20px;
		}
	}
	.infowarp {
		display: flex;
		flex-direction: row;
		.lefthandlebox {
			display: flex;
			flex-direction: column;
			width: 180px;
			align-items: center;
			// justify-content: center;
			.headerImg {
				width: 80px;
				height: 78px;
			}
			.username {
				font-size: 20px;
				font-weight: bold;
				line-height: 31px;
				color: #43424b;
				margin-top: 10px;
			}
			.companybox {
				font-size: 16px;
				line-height: 20px;
				color: #a6a9b7;
				margin-top: 10px;
			}
			/deep/.el-upload--picture-card {
				background-color: #fbfdff;
				border: 1px dashed #c0ccda;
				border-radius: 6px;
				box-sizing: border-box;
				width: 80px;
				height: 80px;
				line-height: 86px;
				vertical-align: top;
				border-radius: 50%;
			}
			/deep/.el-upload-list--picture-card .el-upload-list__item {
				width: 80px;
				height: 80px;
				border-radius: 50%;
			}
		}
		/deep/.el-textarea .el-input__count {
			background: transparent;
			bottom: -28px;
		}
		.rightformbox {
			// width: 1200px;
            overflow-x: auto;
			padding: 0 20px 0 0px;
            // overflow-y: auto;
			.reigstMoney {
				// display: flex;
				// flex-direction: row;
				// margin-left: 10px;
				// width: 96.2%;
				/deep/.el-input-group {
					margin-left: 10px;
					width: 96.2%;
				}
			}
			.hiddenform {
				height: 0;
				overflow: hidden;
				transition: all 2s;
			}
			.unfoldbox {
				cursor: pointer;
				display: flex;
				flex-direction: column;
				font-size: 16px;
				line-height: 24px;
				color: #cfd0d6;

				img {
					width: 32px;
					height: 21px;
				}
			}
			// organizingFormItem
			.organizingFormItem {
				position: relative;
				.organizingText {
					position: absolute;
					top: 0px;
					right: -32px;
					cursor: pointer;
					font-size: 14px;
					color: #0083ff;
				}
			}
			.handleBtnBox {
				display: flex;
				flex-direction: row;
				justify-content: center;
				margin: 36px 0;
				.savebtn {
					width: 152px;
					height: 40px;
					background: #0083ff;
					box-shadow: 0px 7px 22px rgba(103, 154, 255, 0.44);
					margin: 0 30px;
				}
				.cancelbtn {
					width: 152px;
					height: 40px;
					border: 1px solid #cfd0d6;
					border-radius: 5px;
					margin: 0 30px;
				}
			}
			/deep/.el-upload--picture-card {
				background-color: #fbfdff;
				border: 1px dashed #c0ccda;
				border-radius: 6px;
				box-sizing: border-box;
				width: 80px;
				height: 80px;
				line-height: 86px;
				vertical-align: top;
			}
			.applicationimg {
				width: 80px;
				height: 80px;
			}
			/deep/.el-upload-list--picture-card .el-upload-list__item {
				width: 80px;
				height: 80px;
			}
		}
	}
}
</style>





